import { ActionTypes, StationCombinationActions } from './station-combinations.actions';
import { StationCombinationState } from './station-combinations.model';

export const stationCombinationState: StationCombinationState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getStationCombinationLoading: false,
  getStationCombinationLoaded: false,
  stationCombination: null,
  addStationCombinationLoading: false,
  addStationCombinationLoaded: false,
  editStationCombinationLoading: false,
  editStationCombinationLoaded: false,
  deleteStationCombinationsLoading: false,
  deleteStationCombinationsLoaded: false,
  changeActivitiesDataLoading: false,
  changeActivitiesDataLoaded: false,
  changeActivitiesData: [],
  heartbeatSettingsDataLoading: false,
  heartbeatSettingsDataLoaded: false,
  heartbeatSettingsData: [],
};

export function stationCombinationReducer(
  state: StationCombinationState = stationCombinationState,
  action: StationCombinationActions,
): StationCombinationState {
  switch (action.type) {
    case ActionTypes.STATION_COMBINATIONS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.STATION_COMBINATIONS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_STATION_COMBINATION:
      return {
        ...state,
        getStationCombinationLoading: true,
        getStationCombinationLoaded: false,
      };
    case ActionTypes.GET_STATION_COMBINATION_COMPLETED:
      return {
        ...state,
        stationCombination: action.payload.data,
        getStationCombinationLoading: false,
        getStationCombinationLoaded: true,
      };
    case ActionTypes.ADD_STATION_COMBINATION:
      return {
        ...state,
        addStationCombinationLoading: true,
        addStationCombinationLoaded: false,
      };
    case ActionTypes.ADD_STATION_COMBINATION_COMPLETED:
      return {
        ...state,
        addStationCombinationLoading: false,
        addStationCombinationLoaded: true,
      };
    case ActionTypes.EDIT_STATION_COMBINATION:
      return {
        ...state,
        editStationCombinationLoading: true,
        editStationCombinationLoaded: false,
      };
    case ActionTypes.EDIT_STATION_COMBINATION_COMPLETED:
      return {
        ...state,
        editStationCombinationLoading: false,
        editStationCombinationLoaded: true,
      };
    case ActionTypes.DELETE_STATION_COMBINATIONS:
      return {
        ...state,
        deleteStationCombinationsLoading: true,
        deleteStationCombinationsLoaded: false,
      };
    case ActionTypes.DELETE_STATION_COMBINATIONS_COMPLETED:
      return {
        ...state,
        deleteStationCombinationsLoading: false,
        deleteStationCombinationsLoaded: true,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        changeActivitiesDataLoading: true,
        changeActivitiesDataLoaded: false,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        changeActivitiesData: action.payload,
        changeActivitiesDataLoading: false,
        changeActivitiesDataLoaded: true,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING:
      return {
        ...state,
        heartbeatSettingsDataLoading: true,
        heartbeatSettingsDataLoaded: false,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED:
      return {
        ...state,
        heartbeatSettingsData: action.payload,
        heartbeatSettingsDataLoading: false,
        heartbeatSettingsDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
